var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.364 20.5095C20.364 21.04 20.1533 21.5487 19.7782 21.9237C19.4031 22.2988 18.8944 22.5095 18.364 22.5095H6.36401C5.83357 22.5095 5.32487 22.2988 4.94979 21.9237C4.57472 21.5487 4.36401 21.04 4.36401 20.5095V4.50952C4.36401 3.97909 4.57472 3.47038 4.94979 3.09531C5.32487 2.72024 5.83357 2.50952 6.36401 2.50952H13.364L20.364 9.50952V11.4454",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.364 2.50952V9.50952H20.364",
    stroke: "#01295F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54979 18.8839V13.2209H11.8891C12.3131 13.2209 12.679 13.3039 12.9869 13.4698C13.2965 13.6339 13.5353 13.8634 13.703 14.1583C13.8708 14.4514 13.9546 14.7925 13.9546 15.1814C13.9546 15.5722 13.8689 15.9142 13.6975 16.2073C13.5279 16.4986 13.2855 16.7244 12.9703 16.8848C12.655 17.0451 12.2808 17.1253 11.8476 17.1253H10.4042V16.0469H11.5932C11.7997 16.0469 11.972 16.011 12.1103 15.9391C12.2504 15.8672 12.3564 15.7667 12.4283 15.6377C12.5002 15.5068 12.5361 15.3547 12.5361 15.1814C12.5361 15.0063 12.5002 14.8551 12.4283 14.7279C12.3564 14.5989 12.2504 14.4994 12.1103 14.4293C11.9702 14.3593 11.7978 14.3242 11.5932 14.3242H10.9185V18.8839H9.54979Z",
    fill: "#01295F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5231 18.8839H14.4299V13.2209H16.5203C17.0973 13.2209 17.5941 13.3343 18.0107 13.5611C18.4292 13.786 18.7518 14.1104 18.9785 14.5344C19.2053 14.9565 19.3186 15.4616 19.3186 16.0497C19.3186 16.6396 19.2053 17.1465 18.9785 17.5705C18.7536 17.9945 18.432 18.3199 18.0135 18.5466C17.595 18.7715 17.0982 18.8839 16.5231 18.8839ZM15.7986 17.7171H16.4706C16.7876 17.7171 17.0558 17.6636 17.2752 17.5567C17.4964 17.4479 17.6633 17.2719 17.7757 17.0285C17.89 16.7834 17.9471 16.4571 17.9471 16.0497C17.9471 15.6423 17.89 15.3178 17.7757 15.0764C17.6614 14.833 17.4927 14.6579 17.2697 14.551C17.0485 14.4422 16.7756 14.3878 16.4512 14.3878H15.7986V17.7171Z",
    fill: "#01295F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8186 18.8839V13.2209H23.6843V14.3325H21.1873V15.4939H23.4382V16.6082H21.1873V18.8839H19.8186Z",
    fill: "#01295F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.9e2cbc2e733a21d2d87c90d0cff7a38a.svg";
export { ForwardRef as ReactComponent };